<template lang="pug">
input.NumberBox.TextInput.TextInput--block(
  :value='value',
  :min='min',
  :max='max',
  :step='step'
  :class='{"NumberBox--step": step, "TextInput--error": hasError, "TextInput--warning": hasWarning}',
  type='number',
  @change='handleChange'
)
</template>

<script>
export default {
  name: 'NumberBox',

  props: {
    /**Варианты выбора */
    type: String,

    /**Текущее значение */
    value: Number,

    min: Number,
    max: Number,
    step: null,

    /**Status */
    hasError: Boolean,
    hasWarning: Boolean
  },

  model: {
    prop: 'value',
    event: 'valueChanged'
  },

  methods: {
    handleChange(event) {
      let newValue = parseFloat(event.target.value)

      if (isNaN(newValue)) {
        newValue = 0
      }

      if (typeof this.min === 'number' && newValue < this.min) {
        newValue = this.min
        //Костыль, если два раза ввели значени меньше min и реактивность не сработала
        this.$el.value = newValue
      }

      if (typeof this.max === 'number' && newValue > this.max) {
        newValue = this.max
        //Костыль, если два раза ввели значени больше max и реактивность не сработала
        this.$el.value = newValue
      }

      this.$emit('valueChanged', newValue)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~base';

.NumberBox {
  &--step {
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: auto;
      margin: 0;
    }

    -webkit-appearance: auto;
    -moz-appearance: auto;
    appearance: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NumberBox.vue